import React, { useState } from 'react'
import {
  CModal,
  CButton,
  CModalHeader,
  CModalBody,
  CForm,
  CModalFooter,
  CDatePicker,
  CFormCheck,
} from '@coreui/react-pro'
import { recalcActiveEvent, recalcPassiveEvent } from './model'
import { changedDateFormatfinsystem } from '../../../libs/utils'

type Props = {
  isOpen: boolean
  onClose: () => void
  type: 'active' | 'passive'
}

const TITLES = {
  active: 'Пересчитать активы',
  passive: 'Пересчитать пассивы',
}

export const RecalcSummaryModal: React.FC<Props> = ({ isOpen, onClose, type }) => {
  const [dateFrom, setDateFrom] = useState<Date | null>(null)
  const [dateTo, setDateTo] = useState<Date | null>(null)
  const [withDelete, setWithDelete] = useState(false)

  const handleSubmit = () => {
    if (!dateFrom || !dateTo) {
      alert('Please fill in all fields')
      return
    }

    const form = {
      dateFrom: changedDateFormatfinsystem(dateFrom),
      dateTo: changedDateFormatfinsystem(dateTo),
      withDelete,
    }

    if (type === 'active') {
      recalcActiveEvent(form)
    } else {
      recalcPassiveEvent(form)
    }

    onClose()
  }

  return (
    <CModal visible={isOpen} onClose={onClose}>
      <CModalHeader style={{ borderBottom: 'none' }}>
        <h4 className="text-center mb-4">{TITLES[type]}</h4>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CDatePicker
            className="mb-2"
            id="dateFrom"
            label="From date"
            onDateChange={setDateFrom}
          />
          <CDatePicker
            className="mb-2"
            id="dateTo"
            label="To date"
            onDateChange={setDateTo}
          />
          <CFormCheck
            className="mb-2"
            id="withDelete"
            label="Предварительно удалить данные"
            checked={withDelete}
            onChange={(e) => setWithDelete(e.target.checked)}
          />
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton className="w-100" onClick={handleSubmit}>
          Start calculate
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
